import "./contactCardStyles.scss";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { paginaDesdeRuta, trackEvent, type CanalContacto } from "../../../../lib/analytics";

export const ContactCard = ({ setOpenModal, setOpenForm }) => {
    const [check, setCheck] = useState(1);
    // Desde la ruta y no por props: este widget lo monta el Layout, así que
    // puede abrirse en cualquier página.
    const { pathname } = useLocation();

    const _trackCanal = (canal: CanalContacto, saleDeLaWeb: boolean) =>
        trackEvent("contacto_canal_elegido", { canal, pagina: paginaDesdeRuta(pathname) }, { inmediato: saleDeLaWeb });

    const SelectedOption = () => {
        if (check === 1) {
            _trackCanal("formulario", false);
            setOpenModal(false);
            setOpenForm(true);
        } else if (check === 2) {
            _trackCanal("whatsapp", true);
            window.open(
                "https://api.whatsapp.com/send/?phone=573018063302&text=%C2%A1Hola%21+Quiero+recibir+asesor%C3%ADa+%EF%BF%BD&type=phone_number&app_absent=0",
                "_blank"
            );
            setOpenModal(false);
        } else if (check === 3) {
            _trackCanal("videollamada", true);
            window.open("https://calendar.app.google/8KmyniuQcAQJeQjp6", "_blank");
            setOpenModal(false);
        } else {
            setOpenModal(false);
        }
    };

    return (
        <>
            <div className="contact_card text-white">
                <div className="top position-relative">
                    <div
                        className="position-absolute"
                        onClick={() => setOpenModal(false)}
                        style={{ top: "30px", right: "30px", cursor: "pointer" }}
                    >
                        <img src="/assets/icons_contact/close_icon.svg" alt="" loading="lazy" decoding="async" />
                    </div>
                    <img
                        className="wanda_icon"
                        src="/assets/icons_contact/wanda.svg"
                        alt="wanda"
                        loading="lazy"
                        decoding="async"
                    />
                    <p className="text-center">
                        <span className="contact_text_uno">¡Hola, soy Wanda!</span>
                        <br />
                        <span className="contact_text_dos">¿Por que medio deseas comunicarte con un asesor?</span>
                    </p>
                </div>
                <div className="middle">
                    {/* <div
                        className="options"
                        style={{ border: check === 3 ? "1px solid #00FEFE" : "1px solid #90A3BF" }}
                        onClick={() => setCheck(3)}
                    >
                        <div className="d-flex align-items-center">
                            <img
                                src="/assets/icons_contact/camera.svg"
                                alt="Videoasistencia"
                                loading="lazy"
                                decoding="async"
                            />
                            <p>Solicita tu videollamada</p>
                        </div>
                        <img
                            src={
                                check === 3
                                    ? "/assets/icons_contact/check_true.svg"
                                    : "/assets/icons_contact/check_false.svg"
                            }
                            style={{ justifySelf: "end" }}
                            loading="lazy"
                            decoding="async"
                        />
                    </div> */}

                    <div
                        className="options"
                        style={{ border: check === 3 ? "1px solid #00FEFE" : "1px solid #90A3BF" }}
                        onClick={() => setCheck(3)}
                    >
                        <div className="d-flex align-items-center">
                            <img
                                src="/assets/icons_contact/phone.svg"
                                alt="Solicita una llamada"
                                loading="lazy"
                                decoding="async"
                            />
                            <p>Solicita una llamada</p>
                        </div>
                        <img
                            src={
                                check === 3
                                    ? "/assets/icons_contact/check_true.svg"
                                    : "/assets/icons_contact/check_false.svg"
                            }
                            style={{ justifySelf: "end" }}
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                    <div
                        className="options"
                        style={{ border: check === 2 ? "1px solid #00FEFE" : "1px solid #90A3BF" }}
                        onClick={() => setCheck(2)}
                    >
                        <div className="d-flex align-items-center">
                            <img
                                src="/assets/icons_contact/whatsapp.svg"
                                alt="Whatsapp"
                                loading="lazy"
                                decoding="async"
                            />
                            <p>Whatsapp</p>
                        </div>
                        <img
                            src={
                                check === 2
                                    ? "/assets/icons_contact/check_true.svg"
                                    : "/assets/icons_contact/check_false.svg"
                            }
                            style={{ justifySelf: "end" }}
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                    {/* <div
                        className="options"
                        style={{ border: check === 3 ? "1px solid #00FEFE" : "1px solid #90A3BF" }}
                        onClick={() => setCheck(3)}
                    >
                        <div className="d-flex align-items-center">
                            <img
                                src="/assets/icons_contact/phone.svg"
                                alt="Solicita una llamada"
                                loading="lazy"
                                decoding="async"
                            />
                            <p>Solicita una llamada</p>
                        </div>
                        <img
                            src={
                                check === 3
                                    ? "/assets/icons_contact/check_true.svg"
                                    : "/assets/icons_contact/check_false.svg"
                            }
                            style={{ justifySelf: "end" }}
                            loading="lazy"
                            decoding="async"
                        />
                    </div> */}
                </div>
                <div className="botton">
                    <button className="btn btn_orange_transparent" onClick={() => setOpenModal(false)}>
                        CANCELAR
                    </button>
                    <button className="ms-3 btn btn_orange" onClick={SelectedOption}>
                        CONFIRMAR
                    </button>
                </div>
            </div>
        </>
    );
};
